import { render, staticRenderFns } from "./CampoTextarea.vue?vue&type=template&id=aace00da&scoped=true"
import script from "./CampoTextarea.vue?vue&type=script&lang=js"
export * from "./CampoTextarea.vue?vue&type=script&lang=js"
import style0 from "./CampoTextarea.vue?vue&type=style&index=0&id=aace00da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aace00da",
  null
  
)

export default component.exports